/* eslint-disable @typescript-eslint/no-explicit-any */

import { useQuery } from '@tanstack/react-query'
import { flatten, uniq } from 'lodash'

import { apiClient } from '../apiClient'

type SubRequest = {
  subrequest_id: string
  question: string[]
  answers: string[]
}

export const SUB_REQUESTS_BY_IDS_KEY = 'sub-requests-by-ids'

export function useGetListFromIds(ids?: string[] | null) {
  return useQuery({
    queryKey: [SUB_REQUESTS_BY_IDS_KEY, ids],
    queryFn: async () =>
      (
        await apiClient.get(`/int/subrequest`, {
          params: { subrequest_ids: ids },
        })
      ).data,
    enabled: Boolean(ids && ids?.length > 0),
    select: (data) => {
      const allQuestions = uniq(flatten(data?.map((subrequest: any) => subrequest.question)))
      return { data, allQuestions } as { data: SubRequest[]; allQuestions: string[] }
    },
    refetchOnWindowFocus: false,
  })
}
